module.exports = "/fonts/salesforce-sans.woff2?5703848c47fcf8be9a4f3de438438060";